import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

export function useIsActivityScoreEnabled() {
  const { currentCommunity } = usePunditUserContext();
  return Boolean(currentCommunity?.activity_score_ui_enabled);
}

export function useIsActivityScoreEnabledOrUpgradable() {
  const { currentCommunityMember } = usePunditUserContext();
  const isAdmin = currentCommunityMember?.is_admin;
  return Boolean(isAdmin);
}

export function useIsCommunityAiIncludedInCurrentPlan() {
  const { currentCommunity } = usePunditUserContext();

  return Boolean(currentCommunity?.community_ai_feature_flag_enabled);
}

export function useShouldShowCommunityAiModal() {
  const { currentCommunityMember } = usePunditUserContext();
  const isAdmin = currentCommunityMember?.is_admin;
  const isCommunityAiDisabled = !useIsCommunityAiIncludedInCurrentPlan();
  const isActivityScoreUiDisabled = !useIsActivityScoreEnabled();
  return isAdmin && (isCommunityAiDisabled || isActivityScoreUiDisabled);
}
